var _g, _path, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 638.399,
    height: 593.286,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M384.3 589.845c-59.6-10.7-144.6-22.9-187.2-153.4-45.5-139-109.1-138.6-109.1-267 0-100.4 128.7-171.5 296.3-169.4 368.9 18 307.3 645 0 589.8z",
    fill: "#00f4b2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M119.5 114.545c8.2-16.8 22.5-29.4 37.8-39.8 4.4-3 8.9-5.8 13.5-8.6 2.8-1.7.2-6-2.5-4.3-16.4 9.9-32.7 21.1-44.5 36.4a81.72 81.72 0 00-8.6 13.8 2.487 2.487 0 104.3 2.5z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M109.5 122.845c-1.2 2.7-2.3 5.4-3.5 8a3.079 3.079 0 00-.3 1.9 2.827 2.827 0 001.1 1.5 2.588 2.588 0 001.9.3 2.827 2.827 0 001.5-1.1c1.2-2.7 2.3-5.4 3.5-8a3.079 3.079 0 00.3-1.9 2.827 2.827 0 00-1.1-1.5 2.588 2.588 0 00-1.9-.3 1.923 1.923 0 00-1.5 1.1z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "M101.4 142.745a181.661 181.661 0 00-4.1 23.2 2.611 2.611 0 002.5 2.5 2.54 2.54 0 002.5-2.5 161.964 161.964 0 013.9-21.9c.8-3-4.1-4.4-4.8-1.3z",
    fill: "#fff"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 286",
    d: "M80.256 281.142c2.948 2.912 5.14 6.618 5.373 10.556a14.738 14.738 0 01-4.441 11.022 15.44 15.44 0 01-11.153 4.426c-4.033-.138-7.928-2.068-11.532-4.98s-6.916-6.807-7.433-11.219 1.769-9.333 5.373-12.245a16.969 16.969 0 0112.842-3.2 19.487 19.487 0 0110.971 5.64z",
    fill: "#2eebb8",
    opacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "blob-shape (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 287",
    d: "M52.537 309.47c6.576 5.368 10.964 14.131 10.7 22.625s-5.193 16.721-11.769 22.3a34.793 34.793 0 01-22.907 8.427c-8.092-.121-16.063-3.341-20.934-8.924S.971 340.331.273 331.662s-.309-18.022 4.563-23.39 14.238-6.75 23.31-6.441 17.815 2.272 24.391 7.639z",
    fill: "#2eebb8",
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "blob-shape (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 288",
    d: "M38.524 275.98a6.673 6.673 0 012.343 4.085 9.7 9.7 0 01-.573 5.135 8.01 8.01 0 01-3.417 4.483 5.756 5.756 0 01-5.464-.281c-1.564-.995-2.466-2.844-3.348-4.6s-1.756-3.4-1.482-4.837 1.695-2.645 3.125-3.554a9.574 9.574 0 014.411-1.629 6.449 6.449 0 014.405 1.198z",
    fill: "#2eebb8",
    opacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "blob-shape (3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 289",
    d: "M19.68 292.425a6.688 6.688 0 01-3.497 3.544 9.567 9.567 0 01-4.096.928c-1.712.078-4.035-.002-5.168-1.308a4.3 4.3 0 01.106-5.162c1.17-1.348 3.452-1.524 5.945-2.294s5.2-2.131 6.455-1.354 1.06 3.694.254 5.646z",
    fill: "#2eebb8",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble2);
export default __webpack_public_path__ + "static/media/bubble2.3d205692aa7143dd2f7571b20f604606.svg";
export { ForwardRef as ReactComponent };